export default __webpack_public_path__ + "static/media/arrow-up.f7d57308.svg";